import { Outlet } from 'react-router-dom'
import styled from 'styled-components'
import { Sidebar } from './Sidebar'
import { Header } from './Header'
import { usePageTitle } from '../../hooks/usePageTitle'
import { tokens } from '../../styles/tokens'

const Root = styled.div`
  display: flex;
  min-height: 100vh;
  background: ${tokens.purple50};
`

const Main = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  min-width: 0;
`

const Body = styled.main`
  flex: 1;
  padding: 36px;
  position: relative;
  overflow-y: auto;

  &::before {
    content: '';
    position: absolute;
    width: 300px;
    height: 300px;
    background: radial-gradient(circle, #e8d5f5 0%, transparent 70%);
    top: -80px;
    right: -60px;
    border-radius: 50%;
    pointer-events: none;
    z-index: 0;
  }
`

const Content = styled.div`
  position: relative;
  z-index: 1;
`

export function AppLayout() {
  const title = usePageTitle()

  return (
    <Root>
      <Sidebar />
      <Main>
        <Header title={title} />
        <Body>
          <Content>
            <Outlet />
          </Content>
        </Body>
      </Main>
    </Root>
  )
}
